<script setup>
import axios from "axios";
import { computed, reactive, ref, watch } from "vue";
import { RecycleScroller } from 'vue3-virtual-scroller';
import 'vue3-virtual-scroller/dist/vue3-virtual-scroller.css';
import moment from 'moment';
import {
    ElTabs,
    ElTabPane,
    ElButton,
    ElSelect,
    ElOption,
    ElInputNumber,
    ElLoading,
    ElDrawer,
    ElRow,
    ElCol,
    ElFormItem,
    ElForm,
    ElDatePicker,
    ElCheckboxGroup,
    ElCheckboxButton,
    ElCheckbox,
    ElMessage
} from "element-plus";
import { Search, InfoFilled } from '@element-plus/icons-vue';
import { formatMoney } from '../../../utils/money';

const emit = defineEmits(['canceli', 'added', 'addflight', 'addflights']);

const props = defineProps({
    form: Object
});

const eform = props.form;

const flightmodel = ref(true);
const searching = ref(false);
const ruleFormRef = ref();
const activeName = ref(0);

const form = reactive({
    city: '',
    dates: '',
    rooms: [
        {
            adults: 1,
            childs: 0,
            childages: []
        }
    ],
    stars: [3, 4]
});

const rules = reactive({
    city: [
        { required: true, message: 'Required', trigger: ['blur', 'change'] }
    ],
    dates: [
        { required: true, message: 'Required', trigger: ['blur', 'change'] }
    ],
});

let result = ref(null);

const submitForm = async (formEl) => {
    if (!formEl) return;
    await formEl.validate((valid, fields) => {
        if (valid) {
            let radts = 0;
            let rchds = 0;

            for (let i = 0; i < form.rooms.length; i++) {
                const room = form.rooms[i];
                radts += parseInt(room.adults);
                rchds += parseInt(room.childs);
            }

            if (radts == eform.adults && rchds == eform.childs) {
                loadflights();
            } else {
                ElMessage({
                    message: 'Adults and Child Count is Incorrect.',
                    type: 'error',
                });
            }
        }
    });
};

const filters = ref({
    search: [],
    inclusions: [],
    ratings: [],
    types: [],
    showfreffered: false
});

const hfilters = ref({
    mbs: [],
    types: []
});

watch(
    () => filters,
    (newValue, oldValue) => {
        filteredHotel();
    },
    { deep: true }
);

const hotels = ref([]);
const inclusions = ref([]);
const ratings = ref([]);
const types = ref([]);
const fhotels = ref([]);

const loadflights = () => {
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });

    axios.post('/hotelapi/search', form)
        .then(function (response) {
            if (response.data.status) {
                hotels.value = response.data.hotels;
                fhotels.value = response.data.hotels;
                inclusions.value = response.data.inclusions;
                ratings.value = response.data.ratings;
                types.value = response.data.types;
            } else {
                hotels.value = [];
                inclusions.value = [];
                ratings.value = [];
                types.value = [];
            }
            loading.close();
        }).catch(error => {
            loading.close();
        });
};

const filteredHotel = () => {
    let hary = JSON.parse(JSON.stringify(hotels.value));
    let hfls = null;
    if (filters.value.showfreffered) {
        hfls = hary.filter(hotel => hotel.preffered == true);
        fhotels.value = hfls;
        fhotels.value = filterByInclusions(fhotels.value);
    } else if (filters.value.search != "") {
        hfls = hary.filter(hotel => hotel.name.toLowerCase().includes(filters.value.search));
        fhotels.value = hfls;
        fhotels.value = filterByInclusions(fhotels.value);
    } else {
        hfls = filterByTypess(filterByRatings(hary));
        fhotels.value = hfls;
        fhotels.value = filterByInclusions(fhotels.value);
    }
};

const filterByRatings = (hotelsl) => {
    if (filters.value.ratings.length > 0) {
        return hotelsl.filter(hotel => filters.value.ratings.includes(hotel.rating));
    } else {
        return hotelsl;
    }
};

const filterByTypess = (hotelsl) => {
    if (filters.value.types.length > 0) {
        return hotelsl.filter(hotel => filters.value.types.includes(hotel.type));
    } else {
        return hotelsl;
    }
};

const filterByInclusions = (hotelsl) => {
    if (filters.value.inclusions.length > 0) {
        return hotelsl.map((hotel) => {
            hotel.ops = hotel.ops.filter((op) => filters.value.inclusions.includes(op.fc[0]));
            return hotel;
        }).filter((hotel) => hotel.ops.length !== 0);
    } else {
        return hotelsl;
    }
};

const selectedhotel = ref(null);
const selecteddetails = ref(null);
const showhoteldetails = ref(false);

const selecthotel = (hotelid) => {
    const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    });

    axios.post('/hotelapi/getdetail', { "id": hotelid })
        .then(function (response) {
            if (response.data.status) {
                selectedhotel.value = response.data.hotel;
                selecteddetails.value = response.data.details;
                showhoteldetails.value = true;
            } else {
                selectedhotel.value = null;
            }
            loading.close();
        }).catch(error => {
            loading.close();
        });
};

const destinationloading = ref(false);
const alldestinations = ref([]);

const getDestinations = (query) => {
    destinationloading.value = true;
    axios.get('/getdestinationlist?q=' + query)
        .then(function (response) {
            destinationloading.value = false;
            alldestinations.value = response.data;
        });
};

const addroom = () => {
    form.rooms.push({
        adults: 1,
        childs: 0,
        childages: []
    });
};

const removeroom = (room) => {
    const index = form.rooms.indexOf(room);
    if (index !== -1) {
        form.rooms.splice(index, 1);
    }
};

const selectroom = (details, hotel, room) => {
    emit('addhotel', details, hotel, room);
};

const getoptions = computed(() => {
    return filterByMeal1(filterByType1(selectedhotel.value.ops));
});

const filterByType1 = (ops) => {
    if (hfilters.value.types.length > 0) {
        return ops.map(item => {
            return {
                ...item,
                rooms: item.rooms.filter(room => hfilters.value.types.includes(room.type))
            };
        }).filter(item => item.rooms.length > 0);
    } else {
        return ops;
    }
};

const filterByMeal1 = (ops) => {
    if (hfilters.value.mbs.length > 0) {
        return ops.map(item => {
            return {
                ...item,
                rooms: item.rooms.filter(room => hfilters.value.mbs.includes(room.mb))
            };
        }).filter(item => item.rooms.length > 0);
    } else {
        return ops;
    }
};

const disabledDate = (time) => {
    return time.getTime() < moment(String(eform.departure_date)).toDate() ||
        time.getTime() > moment(String(eform.departure_date)).add(eform.nights, 'day').toDate();
};

const defaultDate = ref(moment(String(eform.departure_date)).toDate());
</script>

<template>
    <el-drawer
        v-model="flightmodel"
        title="Select Stay"
        @closed="emit('canceli')"
        size="90%"
    >
        <el-form
            label-position="top"
            ref="ruleFormRef"
            :model="form"
            status-icon
            :rules="rules"
            v-if="result == null"
        >
            <el-row :gutter="10">
                <el-col :span="4">
                    <el-form-item label="City" prop="city">
                        <el-select
                            v-model="form.city"
                            filterable
                            remote
                            placeholder="Please enter a keyword"
                            :remote-method="getDestinations"
                            :loading="destinationloading"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="item in alldestinations"
                                :key="item"
                                :label="item"
                                :value="item"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="Dates" prop="dates">
                        <el-date-picker
                            v-model="form.dates"
                            type="daterange"
                            range-separator="To"
                            start-placeholder="Checkin date"
                            end-placeholder="Checkout date"
                            format="DD/MMM/YYYY"
                            value-format="YYYY-MM-DD"
                            :disabled-date="disabledDate"
                            :default-value="defaultDate"
                        />
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item label="Category" prop="stars">
                        <el-select
                            v-model="form.stars"
                            placeholder="Category"
                            style="width: 100%"
                            multiple
                        >
                            <el-option label="5" :value="5" key="5">5 Star</el-option>
                            <el-option label="4" :value="4" key="4">4 Star</el-option>
                            <el-option label="3" :value="3" key="3">3 Star</el-option>
                            <el-option label="2" :value="2" key="2">2 Star</el-option>
                            <el-option label="1" :value="1" key="1">1 Star</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="5">
                    <el-form-item label="Rooms" prop="rooms">
                        <el-dropdown :hide-on-click="false" trigger="click">
                            <el-button type="primary">
                                {{ form.rooms.length }} Rooms
                                <el-tag class="ml-2" v-for="(room, i) in form.rooms" :key="i">
                                    <span>{{ room.adults }}-A</span>
                                    <span v-if="room.childs > 0">{{ room.childs }}-C</span>
                                </el-tag>
                            </el-button>
                            <template #dropdown>
                                <div class="room-seelct-box" style="width: 200px;" v-for="(room, index) in form.rooms" :key="index">
                                    <div class="title">
                                        Room {{ index + 1 }}
                                        <div class="close-btn" v-if="form.rooms.length > 1" @click="removeroom(room)">Remove</div>
                                    </div>
                                    <div class="paxinf">
                                        Adults <el-input-number v-model="room.adults" :min="1" :max="10" size="small" />
                                    </div>
                                    <div class="paxinf">
                                        Children <el-input-number v-model="room.childs" :min="0" :max="10" size="small" />
                                    </div>
                                    <div v-if="room.childs > 0">
                                        <p>Age of Child</p>
                                        <div v-for="(chd, index) in room.childs" :key="index">
                                            <el-select v-model="room.childages[index]" size="small">
                                                <el-option v-for="(x, index) in 17" :key="index" :value="x">{{ x }}</el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                </div>
                                <el-button style="width: 100%" @click="addroom">Add Room</el-button>
                            </template>
                        </el-dropdown>
                    </el-form-item>
                </el-col>

                <el-col :span="2">
                    <el-form-item label="">
                        <el-button
                            style="margin-top: 22px"
                            type="primary"
                            @click="submitForm(ruleFormRef)"
                            :loading="searching"
                            :disabled="searching"
                        >Search</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <el-row :gutter="20" class="affix-container">
            <el-col :span="4" class="scroller1">
                <el-row>
                    <el-col :span="24">
                        <el-input v-model="filters.search" clearable class="mb-2" placeholder="Search here...." />
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-checkbox v-model="filters.showfreffered" label="Show Only Preffered">Show Only Preffered</el-checkbox>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="font16 fw700">Ratings</div>
                    </el-col>
                    <el-col :span="24">
                        <el-checkbox-group v-model="filters.ratings" size="small">
                            <el-checkbox v-for="rate in ratings" :key="rate" :label="rate">{{ rate }} Star</el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="font16 fw700">Inclusions</div>
                    </el-col>
                    <el-col :span="24">
                        <el-checkbox-group v-model="filters.inclusions" size="small">
                            <el-checkbox v-for="inclusion in inclusions" :key="inclusion" :label="inclusion">{{ inclusion }}</el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="font16 fw700">Types</div>
                    </el-col>
                    <el-col :span="24">
                        <el-checkbox-group v-model="filters.types" size="small">
                            <el-checkbox v-for="type in types" :key="type" :label="type">{{ type }}</el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
            </el-col>

            <el-col :span="20" class="scroller2">
                <RecycleScroller
                    class="scroller"
                    :items="fhotels"
                    :item-size="70"
                    key-field="id"
                    v-slot="{ item }"
                >
                    <el-card class="mb-3" shadow="never" :body-style="{ padding: 0 }">
                        <div class="flex">
                            <div class="p-2" style="width: 70%;">
                                <el-text tag="b">{{ item.name }}</el-text> &nbsp;&nbsp;/
                                <el-text tag="b" size="small">{{ item.type }}</el-text>&nbsp;&nbsp;
                                <el-rate
                                    v-model="item.rating"
                                    disabled
                                    show-score
                                    text-color="#ff9900"
                                    size="small"
                                    score-template="{value} Stars"
                                /> &nbsp;&nbsp;
                                <el-tag v-if="item.preffered" type="success" size="small">Preffered</el-tag>
                                <el-text tag="p" size="small">{{ item.address.address }}, {{ item.address.city }}</el-text>
                            </div>
                            <div class="p-2" style="width: 30%; text-align: right">
                                <el-text tag="b" size="large">₹{{ formatMoney(item.ops[0].price) }}</el-text>&nbsp;&nbsp;
                                <el-text tag="b" class="ml-3" size="small">{{ item.ops[0].fc[0] }}</el-text>
                                <el-button class="ml-3" type="success" size="small" @click="selecthotel(item.id)">Select</el-button>
                            </div>
                        </div>
                    </el-card>
                </RecycleScroller>
            </el-col>
        </el-row>
    </el-drawer>

    <el-drawer
        v-model="showhoteldetails"
        title="Select Rooms"
        size="100%"
    >
        <el-row :gutter="20" class="affix-container">
            <el-col :span="6" class="scroller3">
                <el-row>
                    <el-col :span="24">
                        <div class="font16 fw700">Meal</div>
                    </el-col>
                    <el-col :span="24">
                        <el-checkbox-group v-model="hfilters.mbs" size="small">
                            <el-checkbox v-for="type in selectedhotel.mbs" :key="type" :label="type">
                                <el-text size="small">{{ type }}</el-text>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="font16 fw700">Types</div>
                    </el-col>
                    <el-col :span="24">
                        <el-checkbox-group v-model="hfilters.types" size="small">
                            <el-checkbox
                                style="width: 100%; max-width: 100%"
                                v-for="inclusion in selectedhotel.types"
                                :key="inclusion"
                                :label="inclusion"
                            >
                                <el-text size="small">{{ inclusion }}</el-text>
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
            </el-col>

            <el-col :span="18" class="scroller4">
                <el-card class="mb-3" shadow="never" :body-style="{ padding: 0 }">
                    <div class="flex">
                        <el-avatar shape="square" :src="selectedhotel.img" style="min-width: 150px" :size="150" fit="cover" />
                        <div class="p-2" style="width: 100%;">
                            <el-text tag="b">{{ selectedhotel.name }}</el-text>
                            <el-text tag="p" size="small">{{ selectedhotel.type }}</el-text>
                            <el-text tag="p" size="small">Nights - {{ selecteddetails.nights }}</el-text>
                            <el-text tag="p" size="small">CheckIn - {{ selecteddetails.checkinDate }}</el-text>
                            <el-text tag="p" size="small">CheckOut - {{ selecteddetails.checkoutDate }}</el-text>
                            <el-text tag="p" size="small">{{ selectedhotel.address.address }}, {{ selectedhotel.address.city }}</el-text>
                            <el-rate
                                v-model="selectedhotel.rating"
                                disabled
                                show-score
                                text-color="#ff9900"
                                size="small"
                                score-template="{value} Stars"
                            />
                        </div>
                    </div>
                </el-card>

                <el-card class="mb-3" v-for="(item, index) in getoptions" :key="index" shadow="never" :body-style="{ padding: 0 }">
                    <div class="flex">
                        <div class="p-2" style="width: 60%;">
                            <div v-for="(room, index) in item.rooms" :key="index">
                                <el-text tag="b">{{ room.type }} X {{ room.quantity }}</el-text>
                                <el-text> for {{ room.adt * room.quantity }} adults </el-text>
                                <el-text v-if="room.chd > 0"> {{ room.chd * room.quantity }} child </el-text>
                                <el-text tag="b" size="small"> - {{ room.mb }} - </el-text>
                                <el-text tag="b" size="small"> ₹{{ formatMoney(room.price * room.quantity) }}</el-text>
                            </div>
                        </div>
                        <div class="p-2" style="width: 40%; text-align: right">
                            <el-popover
                                placement="top-start"
                                title="Cancellation Policy"
                                :width="500"
                                trigger="hover"
                            >
                                <template #reference>
                                    <el-text v-if="item.ifra" tag="b" size="small" type="success">
                                        Free Cancellation Available <el-icon><InfoFilled /></el-icon>
                                    </el-text>
                                    <el-text v-else tag="b" size="small" type="danger">
                                        No Free Cancellation <el-icon><InfoFilled /></el-icon>
                                    </el-text>
                                </template>
                                <template #default>
                                    <el-table :data="item.pd" border style="width: 100%">
                                        <el-table-column prop="fdt" label="From Date" width="180" />
                                        <el-table-column prop="tdt" label="To Date" width="180" />
                                        <el-table-column prop="am" label="Amount">
                                            <template #default="scope">
                                                ₹ {{ scope.row.am }}
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </template>
                            </el-popover>
                            &nbsp;<el-text tag="b" size="large">₹{{ formatMoney(item.price) }}</el-text>
                            &nbsp;<el-text tag="b" size="small">{{ item.mb }}</el-text>
                            <el-button class="ml-3" type="success" size="small" @click="selectroom(selecteddetails, selectedhotel, item)">Select</el-button>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </el-drawer>
</template>

<style scoped>
.room-seelct-box {
    padding: 10px;
}

.room-seelct-box .title {
    font-size: 1.1em;
    color: #409eff;
    font-weight: 600;
}

.room-seelct-box .close-btn {
    float: right;
}

.room-seelct-box .paxinf {
    padding: 3px;
    display: flow;
}

.room-seelct-box .paxinf .el-input-number {
    right: 12px;
    width: 90px;
    position: absolute;
}

.scroller {
    height: 100%;
    max-height: 100%;
}

.scroller1 {
    height: 89%;
    max-height: 89%;
    overflow-y: scroll;
    overflow-x: hidden;
}

.scroller2 {
    height: 89%;
    max-height: 89%;
    overflow-y: hidden;
    overflow-x: hidden;
}

.scroller3 {
    height: 100%;
    max-height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

.scroller5 {
    height: 70%;
    max-height: 70%;
}

.scroller4 {
    height: 100%;
    max-height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

.affix-container {
    height: 100%;
    max-height: 100%;
}
</style>